import { Modal, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateUser } from '../../actions/userActions';

function ProfileModal({modalOpened, setModalOpened, data}) {
  const theme = useMantineTheme();
  const {password, ...other} = data;
  const [formData, setFormData] = useState(other);
  const [profileUrl, setProfileUrl] = useState("");
  const [coverUrl, setCoverUrl] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const dispatch = useDispatch();
  const params = useParams();
  const [isloading, setIsloading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      event.target.name === "profilePicture"
        ? setProfileImage(img)
        : setCoverImage(img);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let UserData = formData;
    
    // data ? setFormData({ ...formData, profilePicture: data.secure_url }) : console.log("loading");
    if (profileImage) {
      const data = new FormData();
      data.append("file", profileImage);
      data.append("upload_preset", "supertweet");
      data.append("cloud_name", "dwla5abuc");
      fetch("https://api.cloudinary.com/v1_1/dwla5abuc/image/upload", { 
          method: "post",
          body: data
      })
      .then(res => res.json())
      .then(data => {
        setTimeout(()=>{setProfileUrl(data.secure_url)}, 3500);
      })
      .catch(error => {
          console.log(error);
      })
      setTimeout(()=>{postProfile();}, 6500);
    }

    const postProfile =() => {
      UserData.profilePicture = profileUrl;
      dispatch(updateUser(params.id, UserData))
    }

    const postCover =() => {
      UserData.coverPicture = coverUrl;
      dispatch(updateUser(params.id, UserData))
    }

    if (coverImage) {
      const data = new FormData();
      data.append("file", coverImage);
      data.append("upload_preset", "supertweet");
      data.append("cloud_name", "dwla5abuc");
      fetch("https://api.cloudinary.com/v1_1/dwla5abuc/image/upload", { 
          method: "post",
          body: data
      })
      .then(res => res.json())
      .then(data => {
        setTimeout(()=>{setCoverUrl(data.secure_url)}, 3500);
      })
      .catch(error => {
          console.log(error);
      })
      setTimeout(()=>{postCover();}, 5500);
    }

    if((profileImage=== null) && (coverImage === null) ){
      dispatch(updateUser(params.id, formData));
    }
    setIsloading(prev => !prev);

    setTimeout(()=>{
      setIsloading(prev => !prev);
      setModalOpened(false);
    }, 6500); 
  };

  return (
    <Modal
      overlayColor={theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2]}
      overlayOpacity={0.55}
      overlayBlur={3}
      size='55%'
      opened={modalOpened}
      onClose={() => setModalOpened(false)}
    >
      <form className='infoForm' onSubmit={handleSubmit}>
        <h3>Your info</h3>

        <div>
            <input type='text' placeholder='First Name' className='infoInput' name='firstname' onChange={handleChange} value={formData.firstname}/>
            <input type='text' placeholder='Last Name' className='infoInput' name='lastname' onChange={handleChange} value={formData.lastname}/>
        </div>
        <div>
            <input type='text' placeholder='Works at' className='infoInput' name='worksAt' onChange={handleChange} value={formData.worksAt}/>
        </div>
        <div>
            <input type='text' placeholder='Lives In' className='infoInput' name='livesin' onChange={handleChange} value={formData.livesin}/>
            <input type='text' placeholder='Country' className='infoInput' name='country' onChange={handleChange} value={formData.country}/>
        </div>
        <div>
            <input type='text' className="infoInput" placeholder="RelationShip Status" name='relationship' onChange={handleChange} value={formData.relationship}/>
        </div>
        <div>
            Profile Image
            <input type='file' name='profilePicture' onChange={onImageChange}/>
            cover Image
            <input type="file" name='coverPicture' onChange={onImageChange}/>
        </div>

        <button className='button infoButton' type="submit" disabled={isloading}> {isloading ? "loading..." : "Update"} </button>
      </form>
    </Modal>
  );
}

export default ProfileModal;